<template>
  <div class="CourseBar">
    <div v-if="list.length > 0" ref="list" class="list">
      <template v-if="list.length > 3">
        <div class="nav nav-left" @click="navLeft" v-if="navLeftIndex > 0">
          <i class="el-icon-arrow-left" />
        </div>
        <div class="nav nav-right" @click="navRight" v-if="navLeftIndex < maxNavLeftIndex">
          <i class="el-icon-arrow-right" />
        </div>
      </template>
      <div style="overflow: hidden">
        <div
          class="item-container clearfix"
          :style="{
            width: `${list.length * 300}px`,
            marginLeft: `${-navLeftIndex * 2 * 300}px`,
          }"
        >
          <div
            class="item"
            :class="{
              selected: index == currentIndex,
            }"
            v-for="(item, index) in list"
            :key="item.course_id"
            @click="handlerCourseClick(index)"
          >
            <span v-if="item.is_last_time_viewed === 1" class="last-viewed">上次学到</span>
            <img
              v-if="item.valid_status != 1"
              class="expire"
              src="@/modules/stu/images/expire@2x.png"
            />
            <div class="content">
              <div class="title">
                <span class="multi-line-1" :title="item.title">{{ item.title }}</span>
              </div>
              <div class="time">
                <template v-if="!isInteractive">
                  <span v-if="item.start_play_date > 0">
                    {{ new Date(item.start_play_date * 1000).format('MM月dd日') }}-{{
                      new Date(item.end_play_date * 1000).format('MM月dd日')
                    }}
                  </span>
                  <span v-if="item.course_type != 3 && item.start_play_date > 0" class="line">
                    |
                  </span>
                </template>
                <span v-else>包含课节:</span>
                <span v-if="item.course_type != 3">
                  {{ !isInteractive ? `共${item.section_num}课节` : `${item.section_num}节` }}
                </span>
              </div>
              <div class="valid">
                <span v-highlight="item.valid_date_txt"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
    <EmptyNew title="当前还没有课程可以学习，快去报名课程吧～" v-else></EmptyNew>
  </div>
</template>

<script>
import EmptyNew from '@/components/EmptyNew';

export default {
  name: 'CourseBar',
  components: {
    EmptyNew,
  },
  props: {
    initSelectedIndex: {
      type: Number,
      default: 0,
    },
    list: [],
    isInteractive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentIndex: this.initSelectedIndex,
      navLeftIndex: 0,
    };
  },
  computed: {
    maxNavLeftIndex() {
      return Math.max(0, Math.ceil((this.list.length - 3) / 2));
    },
  },
  mounted() {
    // 初始化时，计算需要滚动的位置
    this.navLeftIndex = Math.min(
      this.maxNavLeftIndex,
      this.initSelectedIndex % 2 === 0
        ? this.initSelectedIndex / 2
        : (this.initSelectedIndex - 1) / 2,
    );
  },
  directives: {
    highlight(el, binding) {
      const text = binding.value;
      if (!text) return '';
      const regex = /#(.*?)#/g;
      el.innerHTML = text.replace(
        regex,
        // eslint-disable-next-line no-useless-escape
        '<span style="color: #ff2d28;">\$1</span>',
      );
    },
  },
  methods: {
    async handlerCourseClick(index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index;
        this.$emit('changeCourse', index);

        this.$webSeeSendTrack({
          event_id: 'my_courses_item_click',
          event_type: 'click',
          data: {
            course_id: this.list[index].course_id,
            course_title: this.list[index].title,
          },
        });
      }
    },
    navLeft() {
      if (this.navLeftIndex == 0) {
        return;
      }
      this.navLeftIndex--;
    },
    navRight() {
      if (this.navLeftIndex >= this.list.length - 1) {
        return;
      }
      this.navLeftIndex++;
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  // padding-bottom: 24px;
  position: relative;
  background: #fff;
  padding: 0 40px;
  .nav {
    // width: 16px;
    // height: 16px;
    position: absolute;
    top: 54px;
    z-index: 9;
    font-size: 16px;
    color: rgba(153, 153, 153, 0.9);
  }

  .nav-left {
    background-image: none;
    left: 16px;

    &:hover {
      color: rgba(51, 51, 51, 0.9);
    }
  }

  .nav-right {
    background-image: none;
    &:hover {
      color: rgba(51, 51, 51, 0.9);
    }

    right: 16px;
  }

  .item {
    width: 276px;
    height: 128px;
    margin-right: 24px;
    float: left;
    cursor: pointer;
    box-sizing: border-box;
    position: relative;

    &.selected {
      background-image: url(~@/modules/stu/images/member/rect-current@3x.png);
      background-repeat: no-repeat;
      border: none;
      background-size: 295px 145px;
      background-position: center -9px;

      .content {
        border: none;
      }
    }

    .last-viewed {
      position: absolute;
      top: 1px;
      right: 2px;
      display: inline-block;
      padding: 2px 4px;
      border-radius: 0px 3px 0px 4px;
      color: #f55;
      font-size: 10px;
      line-height: 14px;
      background: #ffefec;
    }
    .expire {
      position: absolute;
      width: 58px;
      top: 26px;
      right: 8px;
    }

    .content {
      padding: 17px 16px 0 16px;
      position: relative;
      border: 1px solid #e6e8eb;
      border-radius: 5px;
      height: 120px;
      box-sizing: border-box;
    }

    .title {
      font-size: 16px;
      margin-bottom: 16px;
      line-height: 22px;
      position: relative;
      span {
        font-weight: 500;
      }
    }

    .time {
      font-size: 14px;
      color: #1a1a1a;
      line-height: 20px;
    }

    .line {
      margin: 0 10px;
    }

    .valid {
      font-size: 14px;
      color: #1a1a1a;
      margin-top: 8px;
      line-height: 20px;
      .days {
        color: #ff2d28;
      }
    }
  }
}
</style>
